// @flow

// ! We will use some logging service in future (Sentry, ...)
export const serviceMock = {
    log: (message: string, error: Error) => {}, // eslint-disable-line no-unused-vars
};
